import parseOdds from './parse-odds';
import config from './../config';

export default game => {
  const sapoApostasBase = config.url;
  const date = new Date(game.date);
  let odds = parseOdds(game);
  if (date < new Date()) {
    Object.keys(odds).forEach(key => {
      odds[key].odds = new Array(3).fill(null);
    });
  }
  return {
    id: game.game_id,
    date,
    teams: [
      {
        id: game.team_a_id,
        initials: game.team_a_initials,
        name: game.team_a_name,
        logo: game.team_a_logo
      },
      {
        id: game.team_b_id,
        initials: game.team_b_initials,
        name: game.team_b_name,
        logo: game.team_b_logo
      }
    ],
    odds,
    url: `${ sapoApostasBase }/game-detail/${ game.game_id }`
  };
};
